module.exports = __webpack_public_path__ + "static/media/Infrared.757237ba.jpeg";